import { MAX_DEFAULT_FIELD_SYMBOLS } from 'constants/general';
import * as yup from 'yup';
import type { TLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.types';

export const getEmailSchema = (localize: TLocalize) =>
  yup
    .string()
    .email(localize('validation.email.format') as string)
    .max(
      MAX_DEFAULT_FIELD_SYMBOLS,
      localize('validation.email.max.length', [
        String(MAX_DEFAULT_FIELD_SYMBOLS),
      ]) as string
    );
